import ReactDOM from 'react-dom';
import React from 'react';
import { ModalDialog } from './dialog';

const showDialog = (type, message, options) => {
  if (options == null) {
    options = {size: 'large'};
  }
  switch(type) {
    case 'confirm':
      options.confirmLabel = options.confirmLabel || 'Yes';
      options.abortLabel = options.abortLabel || 'No';
      options.showAbortButton = true;
      break;
    case 'info':
      options.confirmLabel = options.confirmLabel || 'OK';
      options.showAbortButton = (options.showAbortButton === true)
      break;
    case 'error':
      options.confirmLabel = options.confirmLabel || 'OK';
      options.showAbortButton = (options.showAbortButton === true)
      break;
    default:
      options.confirmLabel = options.confirmLabel || 'OK';
      options.showAbortButton = (options.showAbortButton === true)
  }

  const wrapper = document.body.appendChild(document.createElement('div'));

  // props = Object.assign({ message, type, onHide: cleanup}, options);
  const props = Object.assign({ message, type}, options);
  const component = ReactDOM.render(React.createElement(ModalDialog,props), wrapper);
  return component.promise
};

export const confirm = (message, options) => showDialog('confirm', message, options);
export const showInfoModal = (message, options) => showDialog('info', message, options);
export const showErrorModal = (message, options) => showDialog('error', message, options);



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/components/dialogs/index.js